var output = null;
function process(algo) {
  output = {
    "coeffVariationTotalCoral": {},
    "meanTotalCoral": {},
    "probaGoodReef": {},
    "probaPoorReef": {},
    "probaVeryGoodReef": {},
    "probaVeryPoorReef": {}
  };

  for (var strategyId in strategies) {
    if (strategies.hasOwnProperty(strategyId)) {

      var coeffVariationTotalCoralStrategyData = processStrategy(coeffVariationTotalCoral, strategies[strategyId], algo);
      output["coeffVariationTotalCoral"][strategyId] = {
        "data": coeffVariationTotalCoralStrategyData,
        "meanSquaredError": getMeanSquaredError(coeffVariationTotalCoral, coeffVariationTotalCoralStrategyData)
      };

      var meanTotalCoralStrategyData = processStrategy(meanTotalCoral, strategies[strategyId], algo);
      output["meanTotalCoral"][strategyId] = {
        "data": meanTotalCoralStrategyData,
        "meanSquaredError": getMeanSquaredError(meanTotalCoral, meanTotalCoralStrategyData)
      };

      var probaGoodReefStrategyData = processStrategy(probaGoodReef, strategies[strategyId], algo);
      output["probaGoodReef"][strategyId] = {
        "data": probaGoodReefStrategyData,
        "meanSquaredError": getMeanSquaredError(probaGoodReef, probaGoodReefStrategyData)
      };

      var probaPoorReefStrategyData = processStrategy(probaPoorReef, strategies[strategyId], algo);
      output["probaPoorReef"][strategyId] = {
        "data": probaPoorReefStrategyData,
        "meanSquaredError": getMeanSquaredError(probaPoorReef, probaPoorReefStrategyData)
      };

      var probaVeryGoodReefStrategyData = processStrategy(probaVeryGoodReef, strategies[strategyId], algo);
      output["probaVeryGoodReef"][strategyId] = {
        "data": probaVeryGoodReefStrategyData,
        "meanSquaredError": getMeanSquaredError(probaVeryGoodReef, probaVeryGoodReefStrategyData)
      };

      var probaVeryPoorReefStrategyData = processStrategy(probaVeryPoorReef, strategies[strategyId], algo);
      output["probaVeryPoorReef"][strategyId] = {
        "data": probaVeryPoorReefStrategyData,
        "meanSquaredError": getMeanSquaredError(probaVeryPoorReef, probaVeryPoorReefStrategyData)
      };
    }
  }
}

export function getMeanSquaredError(referenceData, modelData, variableId) {
  var stats = getStatistics(referenceData, variableId);

  // Calculate the mean square error on normalised data
  var totalSquareError = 0;
  for (var rowId in referenceData) {
    if (referenceData.hasOwnProperty(rowId) && modelData.hasOwnProperty(rowId)) {
      var referenceRow = referenceData[rowId];
      var modelRow = modelData[rowId];
      for (var j=0; j<referenceRow.data.length; j++) {
        var normalisedReferenceValue = (referenceRow.data[j] - stats.mean) / stats.standardDeviation;
        var normalisedModelValue = (modelRow.data[j] - stats.mean) / stats.standardDeviation;

        totalSquareError += (normalisedModelValue - normalisedReferenceValue) ** 2;
      }
    }
  }

  return totalSquareError / stats.population;
}

// Calculates
// - Population (data count)
// - Mean
// - Standard deviation
var statisticsCache = {};
function getStatistics(data, variableId) {
  var statistic = {
    "population": 0,
    "mean": null,
    "standardDeviation": null
  };

  if (variableId) {
    if (statisticsCache.hasOwnProperty(variableId)) {
      return statisticsCache[variableId];
    }
    statisticsCache[variableId] = statistic;
  }

  // Calculate the mean and population
  var total = 0;
  for (var rowId in data) {
    if (data.hasOwnProperty(rowId)) {
      var row = data[rowId];
      var rowData = row.data;
      for (var j=0; j<rowData.length; j++) {
        var value = rowData[j];
        total += value;
        statistic.population++;
      }
    }
  }
  statistic.mean = total / statistic.population;

  // Calculate the standard deviation
  // using the mean and population calculated above.
  //   https://en.wikipedia.org/wiki/Standard_deviation
  total = 0;
  for (var rowId in data) {
    if (data.hasOwnProperty(rowId)) {
      var row = data[rowId];
      var rowData = row.data;
      for (var j=0; j<rowData.length; j++) {
        var value = rowData[j];
        total += (value - statistic.mean) ** 2;
      }
    }
  }
  statistic.standardDeviation = Math.sqrt(total / (statistic.population - 1));

  return statistic;
}

export function processStrategy(referenceData, strategy, algo) {

  // lookupData is a subset of the referenceData containing only the rows selected by the strategy.
  var lookupData = {};
  for (var i=0; i<strategy.length; i++) {
    var rowId = strategy[i];
    if (referenceData.hasOwnProperty(rowId)) {
      var referenceRow = referenceData[rowId];
      if (referenceRow !== null) {
        lookupData[rowId] = referenceRow;
      }
    }
  }

  var modelData = {};
  if (algo === "nearest-neighbour") {

    // Create the nearest neighbour data
    for (var rowId in referenceData) {
      if (referenceData.hasOwnProperty(rowId)) {
        var lon = referenceData[rowId].lon,
          lat = referenceData[rowId].lat;
        var nearestNeighbour = getNearestNeighbourIds([lon, lat], lookupData, 1)[0];
        if (nearestNeighbour !== null && nearestNeighbour.rowId !== null) {
          var nearestNeighbourId = nearestNeighbour.rowId
          var neighbourRow = referenceData[nearestNeighbourId];
          modelData[rowId] = {
            "copiedFrom": nearestNeighbourId,
            "lon": lon,
            "lat": lat,
            "data": neighbourRow.data
          };
        }
      }
    }
    // For backwards compatibility
  } else if (algo === "bilinear-interpolation") {
    modelData = inverseDistWeight(referenceData, lookupData, 1.0, 4)
  } else if (algo === "inverseDistWeight-p1-n4") {
    modelData = inverseDistWeight(referenceData, lookupData, 1.0, 4)
  } else if (algo === "inverseDistWeight-p1-n6") {
    modelData = inverseDistWeight(referenceData, lookupData, 1, 6)
  } else if (algo === "inverseDistWeight-p2-n4") {
    modelData = inverseDistWeight(referenceData, lookupData, 2, 4)
  } else if (algo === "inverseDistWeight-p2-n6") {
    modelData = inverseDistWeight(referenceData, lookupData, 2, 6)
  }else {
    alert("Unsupported algorythm: " + algo);
  }

  return modelData;
}

function inverseDistWeight(referenceData, lookupData, p, N) {
  var modelData = {};
// Create the bilinear interpolation data
  for (var rowId in referenceData) {
    if (referenceData.hasOwnProperty(rowId)) {
      var lon = referenceData[rowId].lon,
        lat = referenceData[rowId].lat;
      var nearestNeighbours = getNearestNeighbourIds([lon, lat], lookupData, N);

      // If point on top of grid point, use grid point.
      if (nearestNeighbours[0].squaredDistance === 0) {
        var neighbourId = nearestNeighbours[0].rowId;
        var neighbourRow = referenceData[neighbourId];
        modelData[rowId] = {
          "copiedFrom": neighbourId,
          "lon": lon,
          "lat": lat,
          "data": neighbourRow.data
        };

      } else {
        /*
        Else
          sum(xi/di)
          ----------
          sum(1/di)
        xi = grid point i (one of the 4 nerest neighbour points we use for the interpolation)
        di = distance between point and xi
        */

        var dataLength = referenceData[rowId].data.length,
          data = [];

        for (var j=0; j<dataLength; j++) {
          var sum_xi_di = 0,
            sum_1_di = 0;

          for (var i=0; i<nearestNeighbours.length; i++) {
            if (nearestNeighbours[i] !== null && nearestNeighbours[i].rowId !== null) {
              var neighbour = nearestNeighbours[i],
                neighbourId = neighbour.rowId,
                neighbourRow = referenceData[neighbourId];

              var xi = neighbourRow.data[j],
                //di = Math.sqrt(neighbour.squaredDistance);
                di = Math.pow(neighbour.squaredDistance, p/2);
              //di = neighbour.squaredDistance;

              sum_xi_di += xi/di;
              sum_1_di += 1/di;
            }
          }

          data[j] = sum_xi_di / sum_1_di;
        }

        modelData[rowId] = {
          "copiedFrom": "-",
          "lon": lon,
          "lat": lat,
          "data": data
        };
      }

      /*
            var referenceRow = referenceData[nearestNeighbourId];
            modelData[rowId] = {
              "copiedFrom": nearestNeighbourId,
              "lon": referenceRow.lon,
              "lat": referenceRow.lat,
              "data": referenceRow.data
            };
      */
    }
  }
  return modelData;
}

// Save CPU time by returning the square distance (save the square root)
// This will not change the outcome for finding the smallest distance.
function getSquareDistance(point1, point2) {
  var deltaX = point2[0] - point1[0],
    deltaY = point2[1] - point1[1];
  return deltaX*deltaX + deltaY*deltaY;
}

function getNearestNeighbourIds(point, lookupData, numberOfNeighbours) {
  var nearestNeighbourIds = [];
  for (i=0; i<numberOfNeighbours; i++) {
    nearestNeighbourIds[i] = {
      "squaredDistance": null,
      "rowId": null
    }
  }

  var row = null, i, j,
    rowCoordinate = null,
    squaredDistance = null;
  for (var rowId in lookupData) {
    if (lookupData.hasOwnProperty(rowId)) {
      // Variables declared outside the "for loop" to save processing time
      row = lookupData[rowId];
      rowCoordinate = [row.lon, row.lat];
      squaredDistance = getSquareDistance(point, rowCoordinate);


      for (i=0; i<numberOfNeighbours; i++) {
        if (nearestNeighbourIds[i].squaredDistance === null || squaredDistance <= nearestNeighbourIds[i].squaredDistance) {
          for (j=numberOfNeighbours-1; j>i; j--) {
            nearestNeighbourIds[j].squaredDistance = nearestNeighbourIds[j-1].squaredDistance;
            nearestNeighbourIds[j].rowId = nearestNeighbourIds[j-1].rowId;
          }
          nearestNeighbourIds[i].squaredDistance = squaredDistance;
          nearestNeighbourIds[i].rowId = rowId;
          break;
        }
      }
    }
  }
  return nearestNeighbourIds;
}



// WEBPACK FOOTER //
// ./src/app/utils/processing.js